import { ZIndexOrder } from "@/theme";
import { ActionIcon, Tooltip } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { BiCollapse, BiExpand } from "react-icons/bi";

export const CollapseAllButton = ({
  accordionId = "sidebarAccordion",
}: {
  accordionId?: string;
}) => {
  const [state, setState] = useLocalStorage<string[] | boolean | null>({
    key: accordionId + ":sidebarAccordionState",
    defaultValue: true,
  });

  const isCollapsed = Array.isArray(state) || state === true;

  return (
    <Tooltip label={isCollapsed ? "Collapse All" : "Expand All"}>
      <ActionIcon
        aria-label="Collapse All"
        style={{
          position: "absolute",
          bottom: 6,
          right: 6,
          zIndex: ZIndexOrder.SidebarBottomButtons,
        }}
        onClick={() => {
          if (Array.isArray(state) || state === true) {
            setState(null);
          } else {
            setState(true);
          }
        }}
      >
        {isCollapsed && <BiCollapse />}
        {!isCollapsed && <BiExpand />}
      </ActionIcon>
    </Tooltip>
  );
};
